import { useEffect, useRef } from "react"
import { useConfirmStore } from "@/shell/confirm.store"

export function ConfirmDialog() {
  const { open, busy, options, cancel, confirm } = useConfirmStore()
  const confirmRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!open) return
    confirmRef.current?.focus()
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !busy) cancel()
    }
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [open, busy, cancel])

  if (!open || !options) return null

  const { title, message, confirmLabel = "Confirm", cancelLabel = "Cancel", danger } = options

  return (
    <div className="modal-bg" onClick={() => !busy && cancel()}>
      <div
        className="confirm"
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
        aria-label={title}
      >
        <h3 className="confirm__title">{title}</h3>
        {message && <p className="confirm__msg">{message}</p>}
        <div className="confirm__actions">
          <button className="btn btn--ghost btn--sm" onClick={cancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            ref={confirmRef}
            className={"btn btn--sm " + (danger ? "btn--danger" : "btn--primary")}
            onClick={() => void confirm()}
            disabled={busy}
          >
            {busy ? <span className="spinner" style={{ borderTopColor: "#fff" }} /> : null}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
